import {createAction} from "@reduxjs/toolkit";
import {RestrictionSearchCriteria} from "@ots-frontend/ots-data";

export const setUIRestrictionSearchFilter = createAction<RestrictionSearchCriteria>("ots-ui/restriction/setSearchFilter");
